import { clsx } from 'clsx';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';

import type { LcpnTheme } from '../../styles/theme';
import { Icon } from '../Icon';
import { Typography } from '../Typography';

import selectionPattern from './assets/select_pattern.svg';
import { useNavigationBarData } from './NavigationBarProvider';

const useStyles = createUseStyles((theme: LcpnTheme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: 0,
  },

  option: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    flex: '0 0 50%',
    padding: theme.spacing(4),
    gap: theme.spacing(4),
    textAlign: 'left',
    color: theme.colors['green-100'],
    backgroundColor: theme.colors['green-55'],
    '&:focus': {
      backgroundColor: theme.colors['green-100'],
      backgroundImage: `url(${selectionPattern})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      color: theme.colors.white,
    },
  },

  active: {
    backgroundColor: theme.colors['green-100'],
    backgroundImage: `url(${selectionPattern})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    color: theme.colors.white,
  },

  group: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
}));

export function MapSelection() {
  const classes = useStyles();
  const { t } = useTranslation();
  const { selectedExperience, setSelectedExperience } = useNavigationBarData();

  return (
    <div className={classes.container}>
      <button
        className={clsx(classes.option, {
          [classes.active]: selectedExperience !== 'heatMap',
        })}
        onClick={() => setSelectedExperience('pinMap')}
      >
        <div className={classes.group}>
          <Typography variant="p1">
            {t('mapSelection.poiTitle', {
              defaultValue: 'Implementation',
            })}
          </Typography>
          {selectedExperience === 'heatMap' ? (
            <Icon variant="Circle" width={24} height={24} />
          ) : (
            <Icon variant="ActiveCheck" width={24} height={24} />
          )}
        </div>
        <Typography variant="p3">
          {t('mapSelection.poiDescription', {
            defaultValue: 'Implementation studies and programmes',
          })}
        </Typography>
      </button>
      <button
        className={clsx(classes.option, {
          [classes.active]: selectedExperience === 'heatMap',
        })}
        onClick={() => setSelectedExperience('heatMap')}
      >
        <div className={classes.group}>
          <Typography variant="p1">
            {t('mapSelection.heatMapTitle', {
              defaultValue: 'Policy',
            })}
          </Typography>
          {selectedExperience === 'heatMap' ? (
            <Icon variant="ActiveCheck" width={24} height={24} />
          ) : (
            <Icon variant="Circle" width={24} height={24} />
          )}
        </div>
        <Typography variant="p3">
          {t('mapSelection.heatMapDescription', {
            defaultValue: 'The policy context for implementation',
          })}
        </Typography>
      </button>
    </div>
  );
}
